import roles from './roles'

export const roleOptions = [
  {
    id: roles.ADMIN_ID,
    name: roles.ADMIN,
  },
  {
    id: roles.STATION_SHIFT_SUPERVISOR_ID,
    name: roles.STATION_SHIFT_SUPERVISOR,
  },
  {
    id: roles.USER_ID,
    name: roles.USER,
  },
  {
    id: roles.ANALYST_ID,
    name: roles.ANALYST,
  },
  {
    id: roles.STATION_ANALYST_ID,
    name: roles.STATION_ANALYST,
  },
  {
    id: roles.STATION_DIRECTOR_ID,
    name: roles.STATION_DIRECTOR,
  },
]

export default roleOptions
